<template>
    <div>
        <v-menu
            v-model="menu"
            style  = "z-index: 800; margin-left: 10px"
            :close-on-content-click="false"
            offset-y
        >
            <template v-slot:activator="{ on, attrs }" >
                <a
                    v-bind = "attrs"
                    v-on   = "on"
                    class  = "step-icon"
                >
                    <slot name="icon"></slot>
                    <span class="mr-1">{{ documents.length }}</span>
                    <i class="ml-0 pr-2 fas" :class="menu?'fa-caret-up ' + color:'fa-caret-down ' + color"></i>
                </a>
            </template>

            <div class="document-list">
                <p-dms-detail-menu-entry
                    v-for="(document, index) in documents" :key="index"
                    :document    = "document"
                    :enable-drag = "enableDrag"
                    :enable-menu = "enableMenu"
                    :class       = "index > 0 ? 'mt-1' : ''"
                    @selected    = "onSelected"
                />
            </div>
        </v-menu>
    </div>
</template>

<script>

import PDmsDetailMenuEntry from "@/modules/dms/menu/components/private/PDmsDetailMenuEntry.vue";

export default {
    name: "CDmsMenuDetails",

    components: {
        PDmsDetailMenuEntry,
    },

    props: {
        documents: {

        },

        color: {

        },

        enableMenu: {
            default: function () {
                return true;
            }
        },

        enableDrag: {
            default: function () {
                return true;
            }
        }
    },

    data: () => ({
        menu: false,
        count: null,
    }),

    watch: {
        menu () {
            this.$emit("menu", this.menu);
        }
    },

    methods: {
        onSelected (document) {
            this.$emit("selected", document);
        }
    }
}
</script>

<style scoped>

.step-icon i {
    font-size: 20px;
}

.document-list {
    width: 100%;
    padding: 5px;
    background-color: white;
}


</style>